import styled from 'styled-components';

import { SecondaryButton } from 'ui/button';
import { body2, body2Bold, colors, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';

export const HeaderText = styled.p`
  ${body2Bold};
  margin-bottom: ${spacing.half};
`;

export const BodyText = styled.p`
  ${body2};
  color: ${colors.textSecondary};
`;

export const BodyPrimaryText = styled.p`
  ${body2};
  color: ${colors.textPrimary};
`;

export const EditButtonTooltip = styled(Tooltip)`
  float: right;
`;

export const EditButton = styled(SecondaryButton)`
  float: right;
  path {
    stroke: ${colors.grey50}!important;
  }
`;

export const Ul = styled.ul`
  list-style-type: disc;
  list-style-position: inside;
  padding-left: ${spacing.threeQuarter};
`;

export const Li = styled.li`
  ${body2};
  color: ${colors.textPrimary};
  padding-bottom: ${spacing.half};
`;
